import { render, staticRenderFns } from "./out-of-budget-modal.vue?vue&type=template&id=58a7d545&scoped=true&"
import script from "./out-of-budget-modal.vue?vue&type=script&lang=js&"
export * from "./out-of-budget-modal.vue?vue&type=script&lang=js&"
import style0 from "./out-of-budget-modal.vue?vue&type=style&index=0&id=58a7d545&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a7d545",
  null
  
)

export default component.exports